import React from 'react';

import type { QuoteBlockProps } from '../interfaces';
import Quotation from './Quotation';

const QuoteBlock = ({ config, content }: QuoteBlockProps) => {
  return (
    <Quotation
      photoUrl={content?.photo_url || ''}
      isPro={config?.pro_subscription}
      quote={content?.quote || ''}
      source={content?.source}
      title={content?.title}
    />
  );
};

export default QuoteBlock;
